// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnnouncementsTrayController from "./announcements_tray_controller"
application.register("announcements-tray", AnnouncementsTrayController)

import AssetEditController from "./asset_edit_controller"
application.register("asset-edit", AssetEditController)

import AssetFilterController from "./asset_filter_controller"
application.register("asset-filter", AssetFilterController)

import AssetSettingsController from "./asset_settings_controller"
application.register("asset-settings", AssetSettingsController)

// Replaced by asset-manager orchestrator pattern
// import BulkSelectController from "./bulk_select_controller"
// application.register("bulk-select", BulkSelectController)

// import BulkActionsController from "./bulk_actions_controller"
// application.register("bulk-actions", BulkActionsController)

import AssetManagerController from "./asset_manager_controller"
application.register("asset-manager", AssetManagerController)

import AssetItemController from "./asset_item_controller"
application.register("asset-item", AssetItemController)

import FolderItemController from "./folder_item_controller"
application.register("folder-item", FolderItemController)

import AssetLightboxController from "./asset_lightbox_controller"
application.register("asset-lightbox", AssetLightboxController)

import DeliveryEvidenceController from "./delivery_evidence_controller"
application.register("delivery-evidence", DeliveryEvidenceController)

import DownloadButtonController from "./download_button_controller"
application.register("download-button", DownloadButtonController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ExpandableRowController from "./expandable_row_controller"
application.register("expandable-row", ExpandableRowController)

import FloatingMenuController from "./floating_menu_controller"
application.register("floating-menu", FloatingMenuController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FolderNavigateController from "./folder_navigate_controller"
application.register("folder-navigate", FolderNavigateController)

import FolderModalController from "./folder_modal_controller"
application.register("folder-modal", FolderModalController)

// Replaced by asset-manager + asset-item orchestrator pattern
// import DragReorderController from "./drag_reorder_controller"
// application.register("drag-reorder", DragReorderController)

// import KeyboardNavController from "./keyboard_nav_controller"
// application.register("keyboard-nav", KeyboardNavController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PackageStatusController from "./package_status_controller"
application.register("package-status", PackageStatusController)

import PreserveScrollController from "./preserve_scroll_controller"
application.register("preserve-scroll", PreserveScrollController)

import SortableListController from "./sortable_list_controller"
application.register("sortable-list", SortableListController)

import SortSelectController from "./sort_select_controller"
application.register("sort-select", SortSelectController)

import UploadQueueController from "./upload_queue_controller"
application.register("upload-queue", UploadQueueController)

import UploadZoneController from "./upload_zone_controller"
application.register("upload-zone", UploadZoneController)

import ViewPreferencesController from "./view_preferences_controller"
application.register("view-preferences", ViewPreferencesController)

import AdminAssetFilterController from "./admin_asset_filter_controller"
application.register("admin-asset-filter", AdminAssetFilterController)

import AdminAssetViewerController from "./admin_asset_viewer_controller"
application.register("admin-asset-viewer", AdminAssetViewerController)

import AdminSortSelectController from "./admin_sort_select_controller"
application.register("admin-sort-select", AdminSortSelectController)

import ZipImportStatusController from "./zip_import_status_controller"
application.register("zip-import-status", ZipImportStatusController)
